import React from 'react'

const Testimonial = () => {
  return (
    <>
              <section className="testimonial pos-rel pt-145">
            <div className="container">
              <div className="section-title text-center mb-45">
                <span
                  className="sub-title wow fadeInRight"
                  data-wow-duration=".7s"
                >
                  Testimonial
                </span>
                <h3 className="title xb-split-text split-in-right">
                  Happy Client <br /> <span>feedback</span>
                </h3>
              </div>
              <div className="row g-15">
                <div className="col-lg-5 mb-15">
                  <div className="xb-testimonial-wrapper pos-rel">
                    <div className="xb-item--inner ul_li">
                      <div className="xb-item--image">
                        <img src="assets/img/about/dpreview.webp" alt="" />
                      </div>
                      <div className="xb-item--holder">
                        <h3 className="xb-item--title">
                          Parikshit Pahwa <br />{" "}
                          <span>MD of MAX Education Links</span>
                        </h3>
                      </div>
                    </div>
                    <div className="comment-box">
                      <h4 className="comment-title">
                        “Super & Reliable Service”
                      </h4>
                      <div className="comment">
                        Om Softwares has been a game-changer for our online
                        presence. Their website design and development team took
                        our vision and turned it into a stunning reality. The
                        results speak for themselves – our website has never
                        looked better.
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-7 mb-15">
                  <div className="xb-testimonial-wrapper testimonial-left pos-rel">
                    <div className="xb-item--inner ul_li">
                      <div className="xb-item--image">
                        <img src="assets/img/about/dpreview.webp" alt="" />
                      </div>
                      <div className="xb-item--holder">
                        <h3 className="xb-item--title">
                          Ravi Kumar
                          <br /> <span>CEO of Bright Juniors</span>
                        </h3>
                      </div>
                    </div>
                    <div className="comment-box">
                      <h4 className="comment-title">“High & Quality Team”</h4>
                      <p className="comment">
                        Om Softwares truly understands the importance of user
                        experience. They transformed our website into a
                        user-friendly, visually appealing platform that has
                        greatly improved our engagement metrics. Their Social
                        Media Management Services are mind-blowing, adding life
                        to our Instagram and other social profiles. The team at
                        Om Softwares goes beyond being just an agency; they are
                        our trusted digital partners, and we are extremely
                        pleased with the outstanding results.
                      </p>
                    </div>
                    <div className="xb-icon">
                      <img src="assets/img/testimonial/tes_05.png" alt="" />
                    </div>
                  </div>
                </div>
                <div className="col-lg-7 mb-15">
                  <div className="xb-testimonial-wrapper pos-rel">
                    <div className="xb-item--inner ul_li">
                      <div className="xb-item--image">
                        <img src="assets/img/about/dpreview.webp" alt="" />
                      </div>
                      <div className="xb-item--holder">
                        <h3 className="xb-item--title">
                          Jaspreet Singh <br /> <span>CEO Sardar Trading</span>
                        </h3>
                      </div>
                    </div>
                    <div className="comment-box">
                      <h4 className="comment-title">
                        “Fully satisfied with SMM service”
                      </h4>
                      <p className="comment">
                        Working with Om Softwares for our Social Media
                        Management has been an absolute game changer. Their
                        expertise in creating engaging content and managing our
                        social profiles has brought a new level of energy and
                        interaction to our brand. The team has consistently
                        exceeded our expectations, bringing creativity and
                        strategic thinking to every campaign. Our social media
                        presence has grown significantly, and we’ve seen a
                        noticeable increase in engagement and followers. We are
                        extremely satisfied with their results-driven approach
                        and highly recommend their SMM services.
                      </p>
                    </div>
                    <div className="xb-icon">
                      <img src="assets/img/testimonial/tes_05.png" alt="" />
                    </div>
                  </div>
                </div>
                <div className="col-lg-5 mb-15">
                  <div className="xb-testimonial-wrapper testimonial-left pos-rel ">
                    <div className="xb-item--inner ul_li">
                      <div className="xb-item--image">
                        <img src="assets/img/about/dpreview.webp" alt="" />
                      </div>
                      <div className="xb-item--holder">
                        <h3 className="xb-item--title">
                          Navneet Sharma
                          <br /> <span>Chartered Accountant</span>
                        </h3>
                      </div>
                    </div>
                    <div className="comment-box">
                      <h4 className="comment-title">
                        “Best service I ever Get”
                      </h4>
                      <div className="comment">
                        Om Softwares has been fantastic in designing our logo,
                        letterheads, and printable creatives. Their team is
                        highly skilled and responsive, offering great support
                        with software-related needs as well. I’m extremely
                        satisfied with their work and highly recommend their
                        services.
                      </div>
                    </div>
                  </div>
                </div>
                <div className="testimonial-shape xb-blur"></div>
              </div>
            </div>
          </section>
    </>
  )
}

export default Testimonial
